import { ReactComponent } from "./ic_radio_inactive.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const HelpIcon: React.FC<Props> = (Props) => <ReactComponent {...Props} />;

export default HelpIcon;
